/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q2Inputs */

const en_pc_dl_faq_q2 = /** @type {(inputs: Pc_Dl_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I install PdfCraft without administrator rights?`)
};

const zh_pc_dl_faq_q2 = /** @type {(inputs: Pc_Dl_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有管理员权限能安装 PdfCraft 吗？`)
};

/**
* | output |
* | --- |
* | "Can I install PdfCraft without administrator rights?" |
*
* @param {Pc_Dl_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q2 = /** @type {((inputs?: Pc_Dl_Faq_Q2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q2(inputs)
	return zh_pc_dl_faq_q2(inputs)
});
export { pc_dl_faq_q2 as "pc.dl.faq.q2" }